<template>
  <div class="admin-page">
    <!-- 查询筛选区域 生产后台标准顶部搜索栏 -->
    <el-card class="search-card">
      <el-form :model="queryForm" inline label-width="80px">
        <el-form-item label="目标服务器">
          <el-select
            v-model="queryForm.serverName"
            placeholder="请选择服务器"
            @change="handleServerChange"
            style="width:240px"
          >
            <el-option
              v-for="item in serverList"
              :key="item.key"
              :label="item.name"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="Plus" @click="openAddDialog">新增新区预约礼包</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 表格主体区域 -->
    <el-card class="table-card">
      <el-table
        :data="tableData"
        border
        stripe
        v-loading="tableLoading"
        highlight-current-row
        style="width:100%"
      >
        <el-table-column prop="activityId" label="礼包ID" align="center" width="100" />
        <el-table-column prop="activityName" label="礼包名称" align="center" />
        <el-table-column prop="activityType" label="礼包类型" align="center">
          <template #default="scope">
            {{ activityTypeMap[scope.row.activityType] || '未知类型' }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="预约状态" align="center" width="120">
          <template #default="scope">
            <el-tag :type="getTagType(scope.row.status)">
              {{ statusMap[scope.row.status] || '未知' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="预约时间" align="center">
          <template #default="scope">
            {{ scope.row.startDateTime || '-' }} ~ {{ scope.row.endDateTime || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="240">
          <template #default="scope">
            <el-button size="small" @click="openDetailDrawer(scope.row)">查看</el-button>
            <el-button size="small" type="primary" @click="openEditDialog(scope.row)">编辑</el-button>
            <el-button size="small" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-empty v-if="!tableLoading && tableData.length === 0" description="暂无礼包数据" />
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
      v-model="dialogVisible"
      :title="isEdit ? '编辑新区预约礼包' : '新增新区预约礼包'"
      width="800px"
      destroy-on-close
    >
      <el-form ref="formRef" :model="formData" label-width="120px">
        <el-row :gutter="20">
          <el-col span="12">
            <el-form-item label="礼包名称">
              <el-input v-model="formData.activityName" placeholder="请输入礼包名称" />
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="礼包类型">
              <el-select v-model="formData.activityType" placeholder="选择礼包类型" @change="handleTypeChange" style="width:100%">
                <el-option label="一次性限购礼包" :value="1" />
                <el-option label="限时可多次购买礼包" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col span="12">
            <el-form-item label="售价(元)">
              <el-input-number v-model="formData.sellPrice" :min="0" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="单人限购次数">
              <el-input-number v-model="formData.limitCount" :min="0" style="width:100%" :disabled="formData.activityType === 1" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col span="12">
            <el-form-item label="预约状态">
              <el-select v-model="formData.status" style="width:100%">
                <el-option label="禁用" :value="0" />
                <el-option label="正常开启" :value="1" />
                <el-option label="手动关闭" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="预约时间区间">
          <el-date-picker
            v-model="formData.dateRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            format="YYYY-MM-DD HH:mm:ss"
            value-format="YYYY-MM-DD HH:mm:ss"
            style="width:100%"
          />
        </el-form-item>
        <el-form-item label="运营备注">
          <el-input v-model="formData.remark" type="textarea" rows="3" placeholder="备注信息" />
        </el-form-item>
        <el-divider content-position="left">礼包奖励道具配置</el-divider>
        <div class="table-toolbar">
          <el-button size="small" type="primary" icon="Plus" @click="addReward">添加道具</el-button>
        </div>
        <el-table :data="formData.rewardList" border stripe>
          <el-table-column label="道具名称" align="center">
            <template #default="scope">
              <el-input v-model="scope.row.itemName" size="small" placeholder="填写道具名称" />
            </template>
          </el-table-column>
          <el-table-column label="道具数量" align="center">
            <template #default="scope">
              <el-input-number v-model="scope.row.itemNum" :min="1" size="small" />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="90" align="center">
            <template #default="scope">
              <el-button size="small" danger text @click="removeReward(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitForm" :loading="submitLoading">保存</el-button>
        </div>
      </template>
    </el-dialog>

    <!-- 详情抽屉 生产后台标准侧边抽屉 -->
    <el-drawer v-model="drawerVisible" title="礼包详情" size="650" direction="rtl">
      <el-descriptions border column="2">
        <el-descriptions-item label="礼包ID">{{ currentRow.activityId }}</el-descriptions-item>
        <el-descriptions-item label="礼包名称">{{ currentRow.activityName }}</el-descriptions-item>
        <el-descriptions-item label="礼包类型">{{ activityTypeMap[currentRow.activityType] || '-' }}</el-descriptions-item>
        <el-descriptions-item label="预约状态">
          <el-tag :type="getTagType(currentRow.status)">
            {{ statusMap[currentRow.status] || '-' }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="售价(元)">{{ currentRow.sellPrice }}</el-descriptions-item>
        <el-descriptions-item label="单人限购次数">{{ currentRow.limitCount }}</el-descriptions-item>
        <el-descriptions-item label="预约开始时间">{{ currentRow.startDateTime || '-' }}</el-descriptions-item>
        <el-descriptions-item label="预约结束时间">{{ currentRow.endDateTime || '-' }}</el-descriptions-item>
        <el-descriptions-item label="运营备注" :span="2">{{ currentRow.remark || '-' }}</el-descriptions-item>
      </el-descriptions>
      <el-divider />
      <div class="drawer-sub-title">礼包奖励列表</div>
      <el-table :data="currentRow.rewardList" border stripe>
        <el-table-column prop="itemName" label="道具名称" align="center" />
        <el-table-column prop="itemNum" label="道具数量" align="center" />
      </el-table>
    </el-drawer>
  </div>
</template>

<script setup>
import { GAME_API } from '@/utils/apiBase';
import { ref, reactive, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import axios from 'axios'

const baseUrl = `${GAME_API}/api/NewServerReservationAdmin`
//const baseUrl = 'https://localhost:5059/api/NewServerReservationAdmin'
const activityTypeMap = {
  1: '只能购买一次',
  2: '可以购买多次'
}
const statusMap = {
  0: '禁用',
  1: '正常开启',
  2: '手动关闭'
}

// 查询表单
const queryForm = reactive({
  serverName: ''
})
const serverList = ref([])
const tableData = ref([])
const tableLoading = ref(false)

// 弹窗相关
const dialogVisible = ref(false)
const isEdit = ref(false)
const submitLoading = ref(false)
const formRef = ref(null)
const formData = reactive({
  activityId: 0,
  activityName: '',
  activityType: 1,
  dateRange: [],
  sellPrice: 0,
  limitCount: 1,
  status: 1,
  remark: '',
  oldVersion: 0,
  rewardList: []
})

// 详情抽屉
const drawerVisible = ref(false)
const currentRow = ref({})

// 状态标签
const getTagType = (val) => {
  const map = {
    0: 'danger',
    1: 'success',
    2: 'warning'
  }
  return map[val] || ''
}

// 礼包类型切换
const handleTypeChange = (val) => {
  if (val === 1) {
    formData.limitCount = 1
  }
}

// 页面加载
onMounted(() => {
  loadServerList()
})

// 加载服务器列表
const loadServerList = async () => {
  try {
    const token = sessionStorage.getItem('token')
    const res = await axios.get(`${baseUrl}/GetServerNameList`, {
      headers: { Authorization: `Bearer ${token}` }
    })
    serverList.value = (res.data || []).map(s => ({
      key: s,
      name: s
    }))
    if (serverList.value.length > 0) {
      queryForm.serverName = serverList.value[0].key
      loadTableData()
    }
  } catch (err) {
    ElMessage.error(`服务器列表加载失败：${err.message}`)
  }
}

// 切换服务器
const handleServerChange = () => {
  loadTableData()
}

// 加载礼包列表
const loadTableData = async () => {
  if (!queryForm.serverName) return
  tableLoading.value = true
  try {
    const token = sessionStorage.getItem('token')
    const res = await axios.get(`${baseUrl}/GetAllActivityList`, {
      params: { serverName: queryForm.serverName },
      headers: { Authorization: `Bearer ${token}` }
    })
    if (res.data.code === 200) {
      tableData.value = res.data.data || []
    } else {
      ElMessage.error(res.data.msg || '查询失败')
    }
  } catch (err) {
    ElMessage.error(`礼包列表加载异常：${err.message}`)
  } finally {
    tableLoading.value = false
  }
}

// 新增
const openAddDialog = () => {
  isEdit.value = false
  resetForm()
  dialogVisible.value = true
}

// 编辑
const openEditDialog = (row) => {
  isEdit.value = true
  Object.assign(formData, {
    activityId: row.activityId,
    activityName: row.activityName,
    activityType: row.activityType,
    sellPrice: row.sellPrice,
    limitCount: row.limitCount,
    status: row.status,
    remark: row.remark,
    oldVersion: row.version,
    dateRange: row.startDateTime && row.endDateTime ? [row.startDateTime, row.endDateTime] : [],
    rewardList: JSON.parse(JSON.stringify(row.rewardList || []))
  })
  dialogVisible.value = true
}

// 查看详情抽屉
const openDetailDrawer = (row) => {
  currentRow.value = JSON.parse(JSON.stringify(row))
  drawerVisible.value = true
}

// 保存提交
const submitForm = async () => {
  if (!formData.dateRange || formData.dateRange.length !== 2) {
    ElMessage.warning('请选择预约起止时间')
    return
  }
  if (formData.rewardList.length === 0) {
    ElMessage.warning('请至少添加一条礼包奖励')
    return
  }
  submitLoading.value = true
  try {
    const payload = {
      ActivityId: formData.activityId,
      ActivityName: formData.activityName,
      ActivityType: formData.activityType,
      StartDateStr: formData.dateRange[0],
      EndDateStr: formData.dateRange[1],
      SellPrice: formData.sellPrice,
      LimitCount: formData.limitCount,
      Status: formData.status,
      Remark: formData.remark,
      OldVersion: formData.oldVersion,
      RewardList: formData.rewardList
    }
    const token = sessionStorage.getItem('token')
    const res = await axios.post(`${baseUrl}/SaveActivity`, payload, {
      params: { servername: queryForm.serverName },
      headers: { Authorization: `Bearer ${token}` }
    })
    if (res.data.code === 200) {
      ElMessage.success('保存成功')
      dialogVisible.value = false
      loadTableData()
    } else {
      ElMessage.error(res.data.msg)
    }
  } catch (err) {
    ElMessage.error(`提交异常：${err.message}`)
  } finally {
    submitLoading.value = false
  }
}

// 删除
const handleDelete = async (row) => {
  await ElMessageBox.confirm(`确定删除礼包【${row.activityName}】？删除后数据不可恢复`, '提示', {
    type: 'warning'
  }).catch(() => { return })
  try {
    const token = sessionStorage.getItem('token')
    const res = await axios.post(`${baseUrl}/DeleteActivity`, {}, {
      params: { servername: queryForm.serverName, activityId: row.activityId },
      headers: { Authorization: `Bearer ${token}` }
    })
    if (res.data.code === 200) {
      ElMessage.success('删除成功')
      loadTableData()
    } else {
      ElMessage.error(res.data.msg)
    }
  } catch (err) {
    ElMessage.error(`删除失败：${err.message}`)
  }
}

// 奖励行操作
const addReward = () => {
  formData.rewardList.push({ itemName: '', itemNum: 1 })
}
const removeReward = (idx) => {
  formData.rewardList.splice(idx, 1)
}

// 重置表单
const resetForm = () => {
  formData.activityId = 0
  formData.activityName = ''
  formData.activityType = 1
  formData.dateRange = []
  formData.sellPrice = 0
  formData.limitCount = 1
  formData.status = 1
  formData.remark = ''
  formData.oldVersion = 0
  formData.rewardList = []
}
</script>

<style scoped>
.admin-page {
  padding: 16px;
  background-color: #f5f7fa;
  min-height: 100vh;
}
.search-card {
  margin-bottom: 16px;
}
.table-card {
  min-height: 420px;
}
.table-toolbar {
  margin-bottom:12px;
}
.drawer-sub-title {
  font-size:15px;
  font-weight:600;
  margin:16px 0 8px;
}
.dialog-footer {
  text-align:right;
}
</style>
